import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "col-12" }
const _hoisted_2 = { class: "row w-100 p-0" }
const _hoisted_3 = { class: "col-4 font-weight-bold text-left tw-formattedNumberFont d-flex align-items-center" }
const _hoisted_4 = { class: "col-5 font-weight-bold text-right tw-formattedNumberFont d-flex align-items-center justify-content-end" }
const _hoisted_5 = { class: "col-3 font-weight-bold text-right tw-formattedNumberFont d-flex align-items-center justify-content-end" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-between align-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "text-bold mb-0" }, "Détails Assurances")
  ])
], -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "ml-1" }
const _hoisted_9 = {
  key: 2,
  class: "form-control no-border p-0",
  style: {"max-width":"65px","float":"right"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "input-suffix" }, "%", -1)
const _hoisted_11 = { key: 3 }
const _hoisted_12 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["bg-white default-border-radius mb-2", _ctx.expanded ? 'border border-primary' : ''])
    }, [
      _createVNode(_component_q_expansion_item, {
        modelValue: _ctx.expanded,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.expanded) = $event)),
        "expand-icon-class": "hidden"
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t(`demand.product.services.names.finance_ASSUR_DEC`)), 1),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.amountHT), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.amountTTC), 1)
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["card-body", _ctx.expanded ? 'bg-secondary border-top border-primary' : 'bg-white'])
          }, [
            _hoisted_6,
            _createVNode(_component_q_table, {
              class: "my-sticky-header-last-column-table bg-transparent border-0 tw-Assurance-table",
              flat: "",
              bordered: "",
              title: "",
              rows: _ctx.data.beneficiaries,
              columns: _ctx.columns,
              "row-key": "name",
              "hide-pagination": ""
            }, {
              header: _withCtx((props) => [
                _createVNode(_component_q_tr, { props: props }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col) => {
                      return (_openBlock(), _createBlock(_component_q_th, {
                        key: col.name,
                        props: props
                      }, {
                        default: _withCtx(() => [
                          (col.name !== 'selected')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.$t(col.label)), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["props"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              body: _withCtx((props) => [
                _createVNode(_component_q_tr, { props: props }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col) => {
                      return (_openBlock(), _createBlock(_component_q_td, {
                        key: col.name,
                        props: props
                      }, {
                        default: _withCtx(() => [
                          (col.name === 'partyName')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createElementVNode("span", _hoisted_8, _toDisplayString(col.value), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (col.editable && col.name !== 'coverage')
                            ? (_openBlock(), _createBlock(_component_q_input, {
                                key: 1,
                                modelValue: props.row[col.name],
                                "onUpdate:modelValue": ($event: any) => ((props.row[col.name]) = $event),
                                disable: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            : _createCommentVNode("", true),
                          (col.editable && col.name === 'coverage')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createVNode(_component_q_input, {
                                  "model-value": props.row[col.name],
                                  disable: "",
                                  class: "flex-fill m-0",
                                  outlined: "",
                                  dense: "",
                                  "input-class": "text-right"
                                }, {
                                  append: _withCtx(() => [
                                    _hoisted_10
                                  ]),
                                  _: 2
                                }, 1032, ["model-value"])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.c)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(col.value), 1))
                            : _createCommentVNode("", true),
                          (!col.editable && col.type !== 'boolean' && col.name !== 'partyName')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(col.value), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["props"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              _: 1
            }, 8, ["rows", "columns"])
          ], 2)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 2)
  ]))
}